export default {
    methods: {
        getMimeTypes() {
            return {
                pdf: "application/pdf",
                txt: "application/txt",
                docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                doc: "application/msword",
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                xls: "application/vnd.ms-excel",
                pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                ppt: "application/vnd.ms-powerpoint",
                pub: "application/vnd.ms-publisher"
            }
        },

        getOpzioni() {
            return [
                { Opzione: 1, Nome: "Elimina" },
                { Opzione: 2, Nome: "Rinomina" }
            ]
        }
    }
}